// extracted by mini-css-extract-plugin
export default {"modal":"FkXESGQx","textAlignCenter":"Bu_FnHOq","closeButton":"GROGxiy6","noMarginTop":"d3PlUMSw","externalLink":"whteiRgV"};